import {
  SpeakerIcon,
  HomeIcon,
  CalendarIcon,
  HelpIcon,
  EmptyIcon,
} from 'components/Utils/Icons'

export const CHANNEL_INPUT_MAX_LENGTH = 30

export const POPULAR_NAMES = [
  'Customer success',
  'Customer support',
  'Design',
  'Marketing',
  'Engineering',
  'Growth',
  'Human resources',
  'Product',
]

export const KEYCODES = {
  ENTER: 13,
  TAB: 9,
  UP: 38,
  DOWN: 40,
  RIGHT: 39,
  LEFT: 37,
  ESC: 27,
}

// Channel templates for nested notes
export const CHANNEL_TEMPLATES = [
  { icon: EmptyIcon, title: 'Blank', id: null },
  { icon: HomeIcon, title: 'Company Wiki', id: 'AQsxo8bzvPASMy6oXhwhym' },
  { icon: HelpIcon, title: 'Customer Support', id: 'Vj8MnbQYPREbgmfyJju21g' },
  { icon: CalendarIcon, title: 'Product', id: 'Wof7nrw3wK8HDE2wU6MoFy' },
  { icon: SpeakerIcon, title: 'Marketing', id: 'MPCzysJXcwP3Q9dYEBjK4Z' },
]
